<i18n lang='yml' src='../i18n/RoleNameAndNalbs.yml'></i18n>
<i18n lang='yml' src='../i18n/ManageFeatureRoles.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else>
    <template v-for="(nalb, nalbIndex) in featureRoles">
      <div class="white-bg padded margin-bottom" v-if="nalb.name != 'Dashboard'">
        <button type='button' class='btn btn-sm btn-success' v-on:click='newFeatureRole($event, nalbIndex, nalb.id)'>
          <font-awesome-icon :icon="['fas', 'plus']" aria-hidden='true' />
          {{ $t('new_role') }}
        </button>
        <fieldset>
          <legend><h5 class="heading-page">{{ nalb.name }}</h5></legend>
          <template v-for="(role, roleIndex) in nalb.roles">
            <div  class='network-role' v-if="role.abilities.length > 0">
              <input type='hidden' :name='fieldName + "[available_nalb_id]"' :value='nalb.id'>
              <input type='hidden' :name='fieldName + "[id]"' :value='role.id'>

              <div class='form-group row'>
                <div class='col-md-6'>
                  <label :for="'name_en-nalb' + nalbIndex + '-role' + roleIndex">
                    {{ $t('name_en') }}
                    <span class='red'>*</span>
                  </label>
                  <input :id="'name_en-nalb' + nalbIndex + '-role' + roleIndex" class='form-control' v-model='role.nameEN' :name='fieldName + "[name_en]"'>
                </div>
                <div class='col-md-6'>
                  <label :for="'name_fr-nalb' + nalbIndex + '-role' + roleIndex">{{ $t('name_fr') }}</label>
                  <input :id="'name_fr-nalb' + nalbIndex + '-role' + roleIndex" class='form-control' v-model='role.nameFR' :name='fieldName + "[name_fr]"'>
                </div>
              </div>

              <div class='form-group row'>
                <div class='col-sm-12'>
                  <input type='hidden' :name='fieldName + "[default_role]"' value='false' v-if='!role.defaultRole'>
                  <label>
                    <input :id="'default_role-nalb' + nalbIndex + '-role' + roleIndex" type='checkbox' :name='fieldName + "[default_role]"' value='true' v-model='role.defaultRole' v-on:click='selectDefaultRole(roleIndex, nalbIndex)'>
                    {{ $t('default_role') }}
                  </label>
                </div>
              </div>

              <table class='table table-responsive table-condensed table-bordered'>
                <tbody>
                <tr class='text-center'>
                  <td v-for='ability in role.abilities'>
                    <strong>{{ ability.name }}</strong>
                  </td>
                </tr>
                <tr class='text-center'>
                  <td v-for='(ability, abilityIndex) in role.abilities'>
                    <input type='hidden' :name='fieldName + "[abilities][][name]"' :value='ability.name'>
                    <input type='hidden' :name='fieldName + "[abilities][][permission]"' :value='permissions.denied' v-if='ability.permission === permissions.denied'>
                    <label>
                      <span class='sr-only'>{{ ability.name }}</span>
                      <input :id="'permission-nalb' + nalbIndex + '-role' + roleIndex + '-ability' + abilityIndex" type='checkbox' :name='fieldName + "[abilities][][permission]"' :value='permissions.allowed' v-model='ability.permission' v-bind:true-value='permissions.allowed' v-bind:false-value='permissions.denied'>
                    </label>
                    <input type='hidden' :name='fieldName + "[abilities][][abilitable]"' :value='role.abilitable'>
                  </td>
                </tr>
                </tbody>
              </table>

              <div class='form-group row'>
                <div class='col-sm-12'>
                  <button type='button' class='btn btn-sm btn-danger' v-on:click='removeFeatureRole(nalbIndex, roleIndex)'>
                    <span aria-hidden='true'></span>
                    <font-awesome-icon :icon="['fa', 'times']"/>
                    {{ $t('delete_role') }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </fieldset>
      </div>
    </template>
  </div>
</template>

<script>
import { sendAjaxRequest } from '../../../../shared/typescripts/ajax.ts'
    export default {
        props: ['locale', 'endpoint', 'fieldName'],
        data () {
            return { featureRoles: [], featureRoleTemplate: {}, permissions: {}, loading: true }
        },
        mounted () {
            this.$i18n.locale = this.locale;
            sendAjaxRequest('GET', this.endpoint + '.json', 'json', null, this.ajaxSuccess);
        },
        methods: {
            newFeatureRole: function (event, nalb, id) {
                this.featureRoles[nalb].roles.push(JSON.parse(JSON.stringify(this.featureRoleTemplate[id])));
                setTimeout(function() {
                    $(event.target).closest('div').find('.network-role').last()[0].scrollIntoView();
                }, 150);
            },
            removeFeatureRole: function(nalb, index) {
                if (confirm(this.$t('delete_confirm'))) {
                  if(this.featureRoles[nalb].roles.length == 1) {
                    // Can't have 0 roles
                    alert("You can't have less than 1 role");
                  }
                  else {
                    this.featureRoles[nalb].roles.splice(index, 1);
                  }
                }
            },
            selectDefaultRole: function(index, nalb) {
                // TODO: Save as state
                if (this.featureRoles[nalb].roles[index].defaultRole) {
                    for (let i = 0; i < this.featureRoles[nalb].roles.length; i++) {
                        this.featureRoles[nalb].roles[i].defaultRole = false;
                    }
                    this.featureRoles[nalb].roles[index].defaultRole = true;
                }
            },

            ajaxSuccess(data) {
              const self = this;
              self.featureRoles = data['featureRoles'];
              self.featureRoleTemplate = data['featureRoleTemplate'];
              self.permissions = data['permissions'];
              self.loading = false;
            }
        }
    }
</script>
